// SettingsLoginPane.jsx

import React from 'react';

// Components
import LoginEdit from 'settings/wizard/login/LoginEdit';

/**
 * SettingsLoginPane
 *
 * Renders login management controls for the active workspace.
 *
 * @param {object} theme - Active theme tokens for dynamic styling.
 *
 * @returns {ReactNode} The rendered login settings pane.
 */
const SettingsLoginPane = React.memo(({
    theme,
}) => {

    // ----- RENDER ----- //

    return (
        <>
            <div className="settings-modal-pane-header">
                <div className="settings-modal-pane-header-left">
                    <div className="settings-modal-setting-label" style={{ color: theme.foreground }}>
                        Login
                    </div>
                    <div className="settings-modal-setting-description" style={{ color: theme.foregroundMuted }}>
                        Manage login settings
                    </div>
                </div>
            </div>

            <div className="settings-modal-pane-contents">
                <div className="settings-modal-embedded-panel">
                    <LoginEdit />
                </div>
            </div>
        </>
    );
});

// Dev Tools
SettingsLoginPane.displayName = 'SettingsLoginPane';

export default SettingsLoginPane;
